/**
 * PC申請成功提示頁面
 */
/* eslint-disable react/jsx-max-depth */
import React from 'react';
import { useIntl, history } from 'umi';
import { Divider } from 'antd';
import classPrefix from 'prefix-classnames';
import * as queryString from 'query-string';
import FooterButton from '@/components/FooterButton';
import { getDefaultBreadcrumbItems } from '@/utils/ServiceConf';
import Breadcrumb from '@/components/Breadcrumb';

import './WebComplete.less';

const px = classPrefix('web-complete') as (param: string) => string;

export default function WebComplete() {
  const intl = useIntl();
  const { isPay = false } = queryString.parse(window.location.search) || {};
  const { workNo } = history.location.query || {};

  return (
    <>
      <div className={px('root')}>
        {/* 面包屑 */}
        <div className={px('breadcrumb')}>
          <Breadcrumb itemList={getDefaultBreadcrumbItems()} />
        </div>
        <div className={px('title')}>{intl.formatMessage({ id: 'Demo事项' })}</div>
        <div className={px('container')}>
          <div className={px('header')}>
            <div className={px('img')}>
              <div className={px('tick')} />
            </div>
            <div className={px('successWarn')}>
              {intl.formatMessage({ id: isPay ? '支付成功' : '成功提交申请' })}
            </div>
          </div>
          <Divider className={px('dashedDivider')} />
          <div className={px('content')}>
            <div className={px('nameItem')}>
              <div className={px('itemValue')}>{intl.formatMessage({ id: 'Demo事项' })}</div>
            </div>
            <div className={px('successInfoArea')}>
              <div className={px('infoItem')}>
                <div className={px('itemKey')}>{intl.formatMessage({ id: '申请编号' })}</div>
                <div className={px('itemNumber')}>{workNo}</div>
              </div>
            </div>
            <Divider className={px('dashedDivider')} />
            <div className={px('successMsg')}>
              {intl.formatMessage(
                {
                  id: '您可登入查询本申请进度，审批完成后系统亦会显示通知',
                },
                {
                  app: <span className={px('text')}>{intl.formatMessage({ id: '一户通' })}</span>,
                },
              )}
            </div>
          </div>
        </div>
      </div>
      <FooterButton
        className={px('footer-button')}
        handleComplete={() => {
          // 关闭当前或上层窗口
          window.top.close();
        }}
      />
    </>
  );
}
